export default __webpack_public_path__ + "static/B0098-98396c2369c2bb25fa247e684e8f057e.png";